import { memo, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import DashboardContext from '../../Context';
import { useScreenSizeChecker } from '../hooks/ScreenSize/useScreenSizeChecker';
import HederHelmet from './HederHelmet';
import NavbarUp from './NavbarUp'
import Sidbar from './Sidbar'
import SignalrClient from './SignalrClient';

/**
 * این کامپوننت برای مدیریت کامپوننت ها تکراری در  صفحه است
 */
function Layout({ children }) {
    const screenSizeChecker = useScreenSizeChecker()
    const { location } = useHistory()

    const { handelAccessPage } = useContext(DashboardContext)

    useEffect(() => {
        handelAccessPage(location.pathname)
    }, [])

    const [showSlider, setShowSlider] = useState(!screenSizeChecker?true:false)

    const handelSlider = () => setShowSlider(!showSlider)


    return (
        <div className="container-scroller">
            <NavbarUp handelSlider={handelSlider} />
            <HederHelmet />
            <div className="container-fluid page-body-wrapper">
                {
                    showSlider ? <Sidbar showSlider={showSlider} /> : null
                }

                <div className='main-panel' style={showSlider ? {} : { width: '100%' }} >
                    <div className='content-wrapper' >

                        {children}
                        <SignalrClient />
                    </div>
                </div>
            </div>

        </div >
    )
}
export default memo(Layout)